module.exports = __webpack_public_path__ + "img/autocrypt_mobility_logo_square_white.13ffeddc.png";